export const useDragInertia = (element: MaybeRef) => {
  const velocityX = ref(0)
  const inertiaAnimationFrame = ref()
  const FRICTION_COEFF = 0.9 // coeff (0 < FRICTION_COEFF < 1)
  const MIN_VELOCITY = 0.5

  const onDragScrollStart = () => {
    if (inertiaAnimationFrame.value) {
      cancelAnimationFrame(inertiaAnimationFrame.value)
      inertiaAnimationFrame.value = null
    }
    velocityX.value = 0
  }

  const onDragScrollMove = (e: CustomEvent) => {
    velocityX.value = e.detail.deltaX
  }

  const onDragScrollEnd = async () => {
    await nextTick()
    applyInertia()
  }

  const applyInertia = () => {
    const container = element.value
    if (!container) {
      return
    }

    const step = () => {
      if (Math.abs(velocityX.value) < MIN_VELOCITY) {
        velocityX.value = 0
        inertiaAnimationFrame.value = null
        return
      }

      container.scrollLeft += velocityX.value
      velocityX.value *= FRICTION_COEFF
      inertiaAnimationFrame.value = requestAnimationFrame(step)
    }
    inertiaAnimationFrame.value = requestAnimationFrame(step)
  }

  return { onDragScrollStart, onDragScrollMove, onDragScrollEnd }
}
